import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// Auth lives only in httpOnly cookies set by the backend; clear any legacy stored token.
localStorage.removeItem("aurora_token");

export const refreshSession = () => api.post("/auth/refresh");

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !/\/auth\/(refresh|login|logout|register|google)/.test(String(orig.url))) {
      orig._retry = true;
      try {
        refreshing = refreshing || refreshSession();
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const wsUrl = (path) => `${BACKEND_URL.replace(/^http/, "ws")}/api${path}`;
